import { RouteObject } from "react-router-dom";
import clinicMasterRouteList from "./routeList";
import PrivateRoute from "../../Authentication/component/PrivateRoute";
import { lazy } from "react";
import Loader from "../../utilis/component/SkeletonLoading/Loader";
import SubDepartmentMaster from "./SubDepartmentMasters";
import CategoryMaster from "./CategoryMaster";
import AddOrEditCategory from "./CategoryMaster/AddOrEditCategory";
import AddOrSubDepartment from "./SubDepartmentMasters/AddOrEditSubdepartment";
const DenialCodeMaster = lazy(()=>import("./DenialCodeMaster"));
const AddOrEditDenialCode = lazy(()=>import("./DenialCodeMaster/AddOrEditDenialCode"));
const CptGroupMaster = lazy(() => import("./CptGroupMaster"));
const AddOrEditCptGroup = lazy(
  () => import("./CptGroupMaster/AddOrEditCptGroup")
);
const ComplaintMaster = lazy(() => import("./ComplaintMaster"));
const AddOrEditComplaint = lazy(
  () => import("./ComplaintMaster/AddOrEditComplaint")
);
const DiseaseMaster = lazy(() => import("./DiseaseMaster"));
const AddOrEditDisease = lazy(() => import("./DiseaseMaster/AddOrEditDisease"));
const FrequencyMaster = lazy(() => import("./FrequencyMaster"));
const AddOrEditFrequency = lazy(
  () => import("./FrequencyMaster/AddOrEditFrequency")
);
const AddOrEditBloodGroup = lazy(
  () => import("./BloodGroupMaster/AddOrEditBloodGroup")
);
const BloodGroupMaster = lazy(() => import("./BloodGroupMaster"));
const AddOrEditHPI = lazy(() => import("./HPIMaster/AddOrEditHPI"));
const RateMaster = lazy(() => import("./RateMaster"));
const HPIMaster = lazy(() => import("./HPIMaster"));
const ICDMasters = lazy(() => import("./IcdMaster"));
const AddOrEditPage = lazy(() => import("./IcdMaster/AddOrEditPage"));
const UploadedData = lazy(() => import("./IcdMaster/UploadedData"));
const AddOrEditRos=lazy(()=>import("./RosMaster/AddOrEditROS"))
const RosMaster=lazy(()=>import("./RosMaster/index"))
const CptMaster=lazy(()=>import("./cptMaster/index"))
const AddOREditCptMaster=lazy(()=>import("./cptMaster/AddOrEditCPT"))
const LoincMaster=lazy(()=>import("./LoincMaster/index"))
const AddOREditLoincMaster=lazy(()=>import("./LoincMaster/AddOrEditLoinc"))

const clinicMastersRoute: RouteObject[] = [
  {
    path: clinicMasterRouteList.icdMaster,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <ICDMasters />
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: clinicMasterRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <AddOrEditPage />
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: clinicMasterRouteList.icdUploadedList,
        element: (
          <PrivateRoute>
            <Loader>
              <UploadedData />
            </Loader>
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: clinicMasterRouteList.rateMaster,
    element: (
      <PrivateRoute>
        <Loader>
          <RateMaster />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: clinicMasterRouteList.hpiMaster,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <HPIMaster />
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: clinicMasterRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <AddOrEditHPI />
            </Loader>
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: clinicMasterRouteList.RosMaster,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <RosMaster/>
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: clinicMasterRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <AddOrEditRos/>
            </Loader>
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: clinicMasterRouteList.bloodGroupMaster,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <BloodGroupMaster />
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: clinicMasterRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <AddOrEditBloodGroup />
            </Loader>
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: clinicMasterRouteList.frequency,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <FrequencyMaster />
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: clinicMasterRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <AddOrEditFrequency />
            </Loader>
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: clinicMasterRouteList.diseaseMaster,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <DiseaseMaster />
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: clinicMasterRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <AddOrEditDisease />
            </Loader>
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: clinicMasterRouteList.complaintMaster,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <ComplaintMaster />
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: clinicMasterRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <AddOrEditComplaint />
            </Loader>
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: clinicMasterRouteList.cptGroupMaster,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <CptGroupMaster />
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: clinicMasterRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <AddOrEditCptGroup />
            </Loader>
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: clinicMasterRouteList.cptMaster,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <CptMaster/>
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: clinicMasterRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <AddOREditCptMaster/>
            </Loader>
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: clinicMasterRouteList.loincMaster,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <LoincMaster/>
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: clinicMasterRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <AddOREditLoincMaster/>
            </Loader>
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: clinicMasterRouteList.denialCode,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <DenialCodeMaster />
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: clinicMasterRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <AddOrEditDenialCode />
            </Loader>
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: clinicMasterRouteList.subDepartment,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <SubDepartmentMaster />
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: clinicMasterRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <AddOrSubDepartment />
            </Loader>
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: clinicMasterRouteList.category,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <CategoryMaster />
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: clinicMasterRouteList.addOrEdit,
        element: (
          <PrivateRoute>
            <Loader>
              <AddOrEditCategory />
            </Loader>
          </PrivateRoute>
        ),
      },
    ],
  },
];

export default clinicMastersRoute;
